import Button from 'atoms/Button';
import Modal from 'atoms/Modal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { closeModal } from 'store/layoutSlice';
import { deleteProject } from 'store/projectsThunks';

type DeleteProjectModalProps = {
    projectId?: string;
    projectName?: string;
    taskCount?: number;
};

export const DeleteProjectModal = ({
    projectId,
    projectName,
    taskCount,
}: DeleteProjectModalProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleClose = () => {
        dispatch(closeModal({ name: 'deleteProject' }));
    };

    const handleConfirm = () => {
        if (!projectId) return;

        setIsDeleting(true);
        dispatch(deleteProject(projectId))
            .then(() => {
                handleClose();
            })
            .catch(() => {
                setIsDeleting(false);
            });
    };

    return (
        <Modal size="s" open={true} onClose={handleClose}>
            <header>
                <h2>Delete Project</h2>
            </header>
            <main>
                <p style={{ marginBottom: '24px' }}>
                    Are you sure you want to delete{' '}
                    <strong>'{projectName}'</strong>?
                    {taskCount && taskCount > 0 && (
                        <>
                            {' '}
                            This project contains <strong>{taskCount}</strong>{' '}
                            task{taskCount === 1 ? '' : 's'}.
                        </>
                    )}{' '}
                    This action cannot be undone.
                </p>
            </main>
            <footer>
                <div />
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        justifyContent: 'center',
                    }}
                >
                    <Button size="m" theme="blank" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        size="m"
                        theme="primary"
                        onClick={handleConfirm}
                        loading={isDeleting}
                    >
                        Delete
                    </Button>
                </div>
            </footer>
        </Modal>
    );
};